import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { teamReducer } from "../../../storage/reducers";
import { getPeriodSummary, getTimeoutNumber } from "../utils/context-utils";
import FragmentSummary from "./fragment-summary";

export default class Timeout extends Fragment {
    constructor(team, time) {
        super();

        this.team = team;
        this.time = time;

        this.requiredData = [
            {
                name: "team",
                type: FragmentDataType.Team,
                displayName: "Team",
                title: "Team",
                subtitle: "Select the team"
            },
            {
                name: "time",
                type: FragmentDataType.Time,
                displayName: "Time",
                title: "Time",
                subtitle: "Set the time the timeout was taken",
                isEditable: true
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const { period, milliseconds } = this.time || {};
        const maxPeriods =
            summaryContext.gameConfig.general.periodsInRegulation;

        const timeoutNumber = getTimeoutNumber(
            this.team?.id,
            period,
            summaryContext
        );
        const { period: normalizedPeriod, abbreviation } = getPeriodSummary(
            period,
            maxPeriods
        );

        const message = `${stringifier.ordinalSuffix(
            timeoutNumber + 1
        )} Timeout taken by ${
            this.team?.teamName
        }, at ${stringifier.milisecondsToMMSS(
            milliseconds
        )} in the ${stringifier.ordinalSuffix(
            normalizedPeriod
        )} ${abbreviation}.`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    toString() {
        return `${super.toString()}: for ${
            this.team.teamName
        } at ${this.time.toLocaleTimeString()}`;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            team: teamReducer(this.team, "teamName")
        };
    }
}
